<template>
  <section
    v-loading="loading"
    id="view-lab"
    class="new-case-view case-creation"
  >
    <div class="container-default">
      <div class="case-creation__step case-creation__patient-information">
        <div class="hospital-form vue-form listings-navbar">
          <el-row :gutter="30">
            <el-col :lg="18">
              <ul class="d-flex flex-wrap list-items-group-15">
                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                  >
                    <el-select
                      v-model="caseType"
                      placeholder="Select Case Type"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleSelectionChange"
                    >
                      <el-option
                        v-for="caseType in CaseTypes"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="6">
              <ul
                class="d-flex justify-content-end list-items-group-15 barcode-print"
              >
                <li>
                  <el-button
                    class="btn button-with-icon"
                    auto-insert-space
                    @click="createNewTestConfig"
                  >
                    <span>Create New Config</span>
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
      <div
        class="primary-content-view-new"
        v-loading="loading"
        v-if="getCaseTypeWorkSheets.data"
      >
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table :data="getCaseTypeWorkSheets.data" ref="multipleTable">
            <el-table-column
              label="Display Name"
              prop="name"
              min-width="100"
              sortable="custom"
            >
              <template #default="scope">{{
                scope.row.display_name || "-"
              }}</template>
            </el-table-column>
            <el-table-column
              label="Path Flags"
              prop="name"
              min-width="100"
              sortable="custom"
            >
              <template #default="scope">
                <span
                  v-for="(path, index) of scope.row.path_flags"
                  :key="index"
                >
                  {{ path || "--" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Assay Id" prop="assay_id" width="250">
              <template #default="scope">{{
                scope.row.assay_id || "-"
              }}</template>
            </el-table-column>
            <el-table-column prop="amp_score" label="AMP Score" width="350">
              <template #default="scope">
                <span class="table_cell-ellipsis">{{
                  scope.row.amp_score
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Status" width="130">
              <template #default="{ row }">
                <el-dropdown @command="(command) => updateStatus(row, command)">
                  <div class="column-status">
                    <el-tag :type="row.status ? 'success' : 'warning'">{{
                      row.status ? "Yes" : "No"
                    }}</el-tag>
                  </div>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item command="true" :disabled="row.status">
                        Yes
                      </el-dropdown-item>
                      <el-dropdown-item command="false" :disabled="!row.status">
                        No
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </el-table-column>

            <el-table-column
              prop="action"
              label="Action"
              fixed="right"
              width="170"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      @click="editWorkSheet(scope.row._id)"
                      class="edit-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/profile/edit-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/profile/edit-icon.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div
        class="listings listings__pagination"
        v-if="this.getCaseTypeWorkSheets && this.getCaseTypeWorkSheets.total"
      >
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[10, 25, 50, 100]"
          layout=" prev, pager, next, jumper, sizes ,total"
          :total="getCaseTypeWorkSheets.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      CaseTypes: [
        {
          label: "Covid",
          value: "COVID",
        },
        {
          label: "Covid and Flu",
          value: "COVID_FLU",
        },
        {
          label: "Respiratory",
          value: "RESPIRATORY_PATHOGEN_PANEL",
        },
        {
          label: "UTI",
          value: "UTI",
        },
      ],
      caseType: "",
      pageSize: 25,
      page: 1,
      pageSizes: [10, 25, 30, 50],
      loading: false,
    };
  },
  computed: {
    labId() {
      return this.$route.params.lab_id;
    },
    ...mapGetters("labs", [
      "getCaseTypeWorkSheets",
      "getTestConfigUpdateStatus",
    ]),
  },
  async mounted() {},
  methods: {
    prepareParams() {
      return {
        lab_id: this.labId,
        case_type: this.caseType,
        page: this.page,
        limit: this.pageSize,
      };
    },
    async fetchWorkSheets() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("labs/fetchAllWorkSheets", params);
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchWorkSheets();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchWorkSheets();
    },
    handleSelectionChange() {
      this.page = 1;
      this.fetchWorkSheets();
    },
    createNewTestConfig() {
      this.$router.push({
        name: "NewWorkSheet",
        params: {
          lab_id: this.labId,
        },
      });
    },
    editWorkSheet(id) {
      this.$router.push({
        name: "EditWorkSheet",
        params: { lab_id: this.labId, target_name_id: id },
        query: this.$route.query,
      });
    },
    async updateStatus(config, status) {
      try {
        this.loading = true;
        let status1 = null;
        if (status == "false") {
          status1 = false;
        }
        if (status == "true") {
          status1 = true;
        }
        let params = {
          test_report_id: config._id,
          lab_id: this.labId,
          params: { status: status1 },
        };
        await this.$store.dispatch("labs/updateTestConfigStatus", params);
        if (this.getTestConfigUpdateStatus) {
          this.$notify.success({
            title: "Success",
            message: "Test Report Log Status updated successfully",
          });
          await this.fetchWorkSheets();
        } else {
          this.$notify.error({
            title: "Error",
            message:
              this.getError || "Error While Test Report Log Status updated",
          });
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#view-lab {
  .case-creation__card {
    position: relative;
    background: #ffffff;
    border: 1.2px solid #e7e7f7;
    border-radius: 6.40567px;
  }
}
</style>
